import { useTranslation } from 'react-i18next';
import { resources } from '../../../../resources/resources';

interface ICompanyDataProps {
  name: string;
  recom?: string;
  cui?: string;
  iban: string;
}

export default function CompanyData(props: Readonly<ICompanyDataProps>) {
  const { t: translate } = useTranslation();
  const { name, recom, cui, iban } = props;

  return (
    <div className="cs-section">
      <div className="cs-title">
        <h4>{translate(resources.admin.companies.companyDataSection.title)}</h4>
      </div>
      <div className="cs-content">
        <ul className="company-settings-list">
          <li>
            <span>
              {translate(
                resources.admin.companies.companyDataSection.companyName,
              )}
            </span>
            <span>{name}</span>
          </li>
          <li>
            <span>
              <label>
                {translate(resources.admin.companies.companyDataSection.recon)}
              </label>
            </span>
            <span>{recom}</span>
          </li>
          <li>
            <span>
              {translate(resources.admin.companies.companyDataSection.cui)}
            </span>
            <span>{cui}</span>
          </li>
          <li>
            <span>
              {translate(resources.admin.companies.companyDataSection.iban)}
            </span>
            <span>{iban}</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
